/* eslint-disable max-lines-per-function */

import { commonTranslationKeys } from '@dreryk/react-common';
import {
   ButtonVariant,
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
} from '@dreryk/react-components';

import { PriceChangeReason } from '../../../shared/priceChangeReason/priceChangeReason.types';
import { visitSettlementTranslationKeys } from '../../../translations';

import {
   VisitSettlementPriceChangeReasonForm,
   VisitSettlementPriceChangeReasonFormInitializer,
} from './VisitSettlementPriceChangeReasonForm';
import { VisitSettlementUpdatePriceChangeReasonAction } from './VisitSettlementPriceChangeReasonModal.actions';

const t = visitSettlementTranslationKeys.extensions.visitForm.priceChangeReason.modal;

type VisitSettlementPriceChangeReasonModalProps = {
   readonly appointmentId: number;
   readonly onCancel: VoidFunction;
   readonly onPriceChangeReason: (priceChangeReason: PriceChangeReason | null) => void;
   readonly initializer: VisitSettlementPriceChangeReasonFormInitializer;
};

export const VisitSettlementPriceChangeReasonModal = (
   props: VisitSettlementPriceChangeReasonModalProps
): JSX.Element => {
   return (
      <Modal testId={'visitSettlementSummary'} title={t.title} width={ModalWidth.NORMAL}>
         <VisitSettlementPriceChangeReasonForm initializer={props.initializer}>
            {({ handleSubmit, formState }) => (
               <>
                  <VisitSettlementUpdatePriceChangeReasonAction
                     appointmentId={props.appointmentId}
                     onPriceChangeReason={props.onPriceChangeReason}
                     onVisitAlreadySettledFault={props.onCancel}
                  >
                     {({ updatePriceChangeReason }) => (
                        <ModalConfirmButton
                           label={t.saveAction.label}
                           onClick={handleSubmit(updatePriceChangeReason)}
                           variant={ButtonVariant.PRIMARY}
                        />
                     )}
                  </VisitSettlementUpdatePriceChangeReasonAction>

                  <ModalCancelButton
                     label={commonTranslationKeys.cancel}
                     onClick={props.onCancel}
                     shouldConfirmExit={formState.isDirty}
                  />
                  <ModalCloseButton onClick={props.onCancel} shouldConfirmExit={formState.isDirty} />
               </>
            )}
         </VisitSettlementPriceChangeReasonForm>
      </Modal>
   );
};
